import React from 'react'
import {Grid,Card} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectVodafoneInvoicesState, displayInvoiceList, displayMainUtilityView, resetVodafoneInvoicesSlice } from '../../../../../../features/vodafone/vodafoneInvoicesSlice';
import {selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade} from '../../../../../../features/global/globalDataSlice'
import {selectMyContractsState, resetSelectedContractInfo} from '../../../../../../features/myContracts/myContractsSlice'
import smallLoadingAnimation from '../../../../../../icons/lottieAnimations/smallLoading.json'
import Lottie from "lottie-react";
import VodafoneInvoices from './VodafoneInvoices'
import VodafoneInvoiceListMultiSelect from './VodafoneInvoiceListMultiSelect'
import { useLocation } from "react-router-dom";
import colors from '../../../../../colors'
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice';
import MyContractsTest from '../../myContracts/myContractsNew/MyContractsTest';
import { texts } from '../../../../../general/texts';

const UtilityVodafoneInvoices = (props) => {
    const vodafoneInvoicesSliceState = useSelector(selectVodafoneInvoicesState) 
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const dispatch = useDispatch()
    const location = useLocation()
    const userInfo = useSelector(selectUserInfo)
    const utilityName = 'VODAFONE'

const selectedButtonStyle =
{
    backgroundColor: colors.lightOrange,
    color: colors.orange,
    paddingLeft:'21px',
    paddingRight:'21px',
    paddingTop:'6px',
    paddingBottom:'6px',
    fontWeight:'bold',
    border: '2px solid'+colors.orange,
    borderRadius:'10px',
    '&:hover': {
        backgroundColor: colors.lightOrange
    }                     
}

const defaultButtonStyle =
{
    backgroundColor: colors.lightBlue,
    paddingLeft:'21px',
    paddingRight:'21px',
    paddingTop:'6px',
    paddingBottom:'6px',
    borderRadius:'10px',
    color: colors.darkBlue,
    '&:hover': {
        backgroundColor: colors.lightOrange
    }
}

    React.useEffect(()=>{
        vodafoneInvoicesSliceState.shouldDisplayInvoiceList && dispatch(displayInvoiceList())
        vodafoneInvoicesSliceState.shouldDisplayMainUtilityView && dispatch(displayMainUtilityView())
        
        if(vodafoneInvoicesSliceState.isTransactionSuccessfullyCompleted)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-trx"]}))
            dispatch(setTransactionHasBeenMade(true))
            dispatch(resetVodafoneInvoicesSlice())
        }

        return(() => {
            dispatch(resetSelectedContractInfo())
        })
    },[vodafoneInvoicesSliceState.isTransactionSuccessfullyCompleted, vodafoneInvoicesSliceState.shouldDisplayInvoiceList, vodafoneInvoicesSliceState.shouldDisplayMainUtilityView])

    return(
        <Grid container spacing={'2%'} pt={'3%'} >
            <Grid container item md={6.5} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                <Card sx={{borderRadius:'20px', boxShadow:'0 0 15px 5px #E5E7EA', width:'60%', '@media (max-width: 1440px )' : {width:'70%'}, '@media (max-width: 1320px )' : {width:'90%'}}}>
                        {vodafoneInvoicesSliceState.shouldDisplayInvoiceList === false && vodafoneInvoicesSliceState.shouldDisplaySingleInvoice === false && <VodafoneInvoices selectedContractInfo={myContractsSliceState.selectedContractInfo} utilityName={utilityName} defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} vodafoneInvoicesSliceState={vodafoneInvoicesSliceState} utilityInfo={props.utilityInfo} globalDataSliceState={globalDataSliceState}/>}
                        {vodafoneInvoicesSliceState.shouldDisplayInvoiceList === true && <VodafoneInvoiceListMultiSelect utilityInfo={props.utilityInfo} utilityName={utilityName} invoices={vodafoneInvoicesSliceState.invoiceList} globalDataSliceState={globalDataSliceState} vodafoneInvoicesSliceState={vodafoneInvoicesSliceState}/>}  
                        
                        <Grid container justifyContent={'center'}>
                            <Grid item md={3} xs={3}>{vodafoneInvoicesSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}</Grid>
                        </Grid>                                                                     
                    </Card>            
                </Grid>
                <Grid container item md={4.5} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} > 
                    <MyContractsTest utilityName={utilityName} currentLocation='utility'/>
                </Grid>
        </Grid> 
    )
}

export default UtilityVodafoneInvoices